var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoRevisaoIpo2Pt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "36px",
    viewBox: "0 0 35 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Revis\xE3o e IPO &gt; 2pt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS-CATEGORIES",
    transform: "translate(-51.000000, -400.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Revis\\xE3o-e-IPO->-2pt",
    transform: "translate(52.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8904571,13.9477628 L24.5257352,10.8901753 C24.1022008,9.61999615 22.9134217,8.76317635 21.5745612,8.76317635 L13.0275612,8.76317635",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0273917,21.5647254 L20.2817427,21.5647254",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0273917,24.6754773 L22.7797052,24.6754773 L22.7797052,26.7494815 C22.7797052,27.3218252 23.2439396,27.7860596 23.8167073,27.7860596 L27.9642917,27.7860596 C28.5370594,27.7860596 29.0012937,27.3218252 29.0012937,26.7494815 L29.0012938,24.546594 C29.6334156,23.9772179 30.0382958,23.1606742 30.0382958,22.2432283 L30.0382958,20.598694 C30.0382958,19.6596263 29.6652125,18.7591388 29.0012938,18.09522 L29.0012938,17.0586419 L31.074874,16.3786127 C31.6476417,16.3786127 32.111876,15.9143783 32.111876,15.3416106 L32.111876,13.9476356 C32.111876,13.3748679 31.6476417,12.9106335 31.074874,12.9106335 L27.9642917,12.9106335 C27.6174938,12.9106335 24.8210646,16.0216398 22.7797052,16.0216398 L13.0273917,16.0216398",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4997276,18.4893317 C25.2253089,19.5700015 23.849988,19.7450962 22.1668734,19.7450962",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6554146,24.6754773 L22.7797052,24.6754773",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-13",
    points: "6.79155812 0.322632292 0.136260208 0.322632292 0.136260208 9.09772187 8.91134979 9.09772187 8.91134979 7.29589896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-14",
    points: "0.136514583 33.5591426 8.91160417 33.5591426 8.91160417 24.784053 0.136514583 24.784053"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-15",
    points: "2.74640208 3.79820031 5.44913646 6.50093469 10.4047854 1.54528573"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-16",
    points: "6.79155812 12.5533639 0.136260208 12.5533639 0.136260208 21.3284534 8.91134979 21.3284534 8.91134979 19.5266305"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-17",
    points: "2.74640208 16.0289319 5.44913646 18.7316663 10.4047854 13.7760173"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoRevisaoIpo2Pt);
export default __webpack_public_path__ + "static/media/PictoRevisaoIPO_2pt.4d9c62f3aa05671b529b8df614a98efd.svg";
export { ForwardRef as ReactComponent };